import styled from "styled-components";
import { typographyCSS } from "@ifgengineering/design-tokens/legacy";

export type V3DataTableAlign = "left" | "center" | "right";

export const DataTableScroller = styled.div`
  width: 100%;
  overflow-x: auto;
  border-radius: ${({ theme }) => theme.radius.md}px;
  border: ${({ theme }) => theme.stroke.md}px solid
    ${({ theme }) => theme.colors.ui.border.subtle};
  background: ${({ theme }) => theme.colors.ui.background.raised};
`;

export const DataTableElement = styled.table`
  width: 100%;
  border-collapse: collapse;
  caption-side: bottom;
`;

export const DataTableCaption = styled.caption`
  ${typographyCSS("caption.sm")}
  color: ${({ theme }) => theme.colors.ui.text.tertiary};
  text-align: left;
  padding: ${({ theme }) => theme.space.card.inset}px
    ${({ theme }) => theme.space.lg}px;
`;

export const DataTableHeaderCell = styled.th<{ $align: V3DataTableAlign }>`
  ${typographyCSS("caption.sm-medium")}
  font-weight: 600;
  font-size: 11px;
  line-height: 14px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.colors.ui.text.tertiary};
  text-align: ${({ $align }) => $align};
  white-space: nowrap;
  background: ${({ theme }) => theme.colors.ui.background.inset};
  padding: ${({ theme }) => theme.space.card.inset}px
    ${({ theme }) => theme.space.lg}px;
  border-bottom: ${({ theme }) => theme.stroke.md}px solid
    ${({ theme }) => theme.colors.ui.border.subtle};
`;

export const DataTableRow = styled.tr<{ $highlighted: boolean }>`
  background: ${({ theme, $highlighted }) =>
    $highlighted
      ? theme.mode === "dark"
        ? theme.colors.ui.background.inset
        : theme.colors.ui.interactive.primaryDeepTintSubtle
      : "transparent"};
`;

export const DataTableCell = styled.td<{
  $align: V3DataTableAlign;
  $highlighted: boolean;
}>`
  ${typographyCSS("body.sm")}
  color: ${({ theme, $highlighted }) =>
    $highlighted
      ? theme.colors.ui.text.primary
      : theme.colors.ui.text.secondary};
  text-align: ${({ $align }) => $align};
  padding: ${({ theme }) => theme.space.card.inset}px
    ${({ theme }) => theme.space.lg}px;
  border-bottom: ${({ theme }) => theme.stroke.md}px solid
    ${({ theme }) => theme.colors.ui.border.divider};

  tr:last-child & {
    border-bottom: none;
  }
`;
